import { FC, HTMLAttributes, useEffect, useRef, useState } from "react";
import clsx from "classnames";
import { useStyles } from "./ProgressBar.styles";

type ProgressBarSize = "small" | "medium" | "large" | "extraLarge";

interface IProgressBarProps {
  color: string;
  progress?: number;
  initialProgress?: number;
  size?: ProgressBarSize;
}

export const ProgressBar: FC<
  IProgressBarProps & HTMLAttributes<HTMLDivElement>
> = ({ size = "small", progress, initialProgress, color, ...otherProps }) => {
  const classes = useStyles();
  const refBar = useRef<HTMLDivElement>(null);
  const [displayProgress, setDisplayProgress] = useState(
    initialProgress ?? progress ?? 0,
  );

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDisplayProgress(progress ?? 0);
    }, 100);
    return () => clearTimeout(timeout);
  }, [progress]);

  return (
    <div
      {...otherProps}
      className={clsx(classes.root, otherProps.className, size)}
    >
      <div
        ref={refBar}
        style={{
          width: `${displayProgress}%`,
          background: color,
          transition: "width 0.8s ease-in-out",
        }}
        className={clsx(classes.bar, size)}
      />
    </div>
  );
};
